import React from 'react';

export function StatCard({ title, subtitle, isEmpty = false, emptyText = 'Noch keine Daten für diesen Zeitraum.', children }) {
  return (
    <div className="bg-white dark:bg-slate-800 rounded-3xl shadow-xl border border-slate-200/60 dark:border-slate-700/60 p-6">
      {title && <h3 className="text-base font-semibold text-slate-800 dark:text-slate-100">{title}</h3>}
      {subtitle && <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">{subtitle}</p>}
      <div className="mt-4">
        {isEmpty
          ? <div className="text-sm text-slate-400 dark:text-slate-500 py-8 text-center">{emptyText}</div>
          : children}
      </div>
    </div>
  );
}
